module.exports = __webpack_public_path__ + "images/frontpage_download@3x.png?9713542b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_download@3x.png
// module id = 638
// module chunks = 7